import * as types from './types';
import { resolve, reject } from '../../middleware/simple-promise';

const initialState = {
  listings: [],
  listingDetails: {},
  loading: false,
  saving: false
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case types.GET_LISTINGS:
      return {
        ...state,
        loading: true
      };
    case resolve(types.GET_LISTINGS):
      return {
        ...state,
        listings: payload,
        loading: false
      };
    case types.GET_LISTING_DETAILS:
      return {
        ...state,
        loading: true
      };
    case resolve(types.GET_LISTING_DETAILS):
      return {
        ...state,
        loading: false,
        listingDetails: {
          ...state.listingDetails,
          [meta.listingId]: payload
        }
      };
    case types.CREATE_MAPPING:
    case types.SAVE_LISTING_MAPPING: {
        return {
          ...state,
          saving: true
        }
    }
    case resolve(types.CREATE_MAPPING):
    case resolve(types.SAVE_LISTING_MAPPING): {
      const [store, listingId, productId] = meta.productId.split(':');
      const listing = state.listingDetails[listingId];
      const products = listing.inventory.products;
      const product = products.find(p => p.product_id.toString() === productId);
      product.mapping = payload;
      return {
        ...state,
        saving: false,
        listingDetails: {
          ...state.listingDetails,
          [listingId]: {
            ...listing
          }
        }
      };
    }
    case reject(types.SAVE_LISTING_MAPPING):
      return {
        ...state,
        saving: false
      };
    case resolve(types.DELETE_LISTING_MAPPING): {
      const [store, listingId, productId] = meta.productId.split(':');
      const listing = state.listingDetails[listingId];
      const products = listing.inventory.products;
      const product = products.find(p => p.product_id.toString() === productId);
      delete product.mapping;
      return {
        ...state,
        listingDetails: {
          ...state.listingDetails,
          [listingId]: {
            ...listing
          }
        }
      };
    }

    default:
      return state;
  }
};
